module.exports = __webpack_public_path__ + "static/img/jiehun.5c4ae180.png";